import { render, staticRenderFns } from "./legal-notice.vue?vue&type=template&id=d1e1f314&"
import script from "./legal-notice.vue?vue&type=script&lang=js&"
export * from "./legal-notice.vue?vue&type=script&lang=js&"
import style0 from "./legal-notice.vue?vue&type=style&index=0&id=d1e1f314&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Breadcrumb.vue').default})
